export default __webpack_public_path__ + "static/Rabadi-714ec095723943ad3499e472345f02b9.jpg";